import React, { useContext, useEffect, useState } from 'react';
import { useProfileData } from '../../NecttosComp/APICaller/queryHooks';

import { Body, Main, Header } from '../../NecttosComp/Layout/Layout';
import Button from '../../NecttosComp/Button/Button';
import VerificationStudent from './VerificationStudent';
import HandleProceed from './HandleProceed';
import HandleReject from './HandleReject';
import ApplicationOpen from './AdmissionDataEdit';
import CallCandidate from './Callcandidate';
import HandleGiveTime from './HandleGiveTime';
import Rewardback from './Rewardback';
import TimerFunction from './TimerFunction';
import notFoundProfile from '../../static/images/library/noPhotoAvailable.png';
import { getAxiosTokenInstance } from '../../utils/axiosInstance';
import { NecttosContext } from '../../context/NecttosContext';
import Input2 from '../../NecttosComp/Input/Input2';
import { useQuery } from 'react-query';

export const getCollegeDetails = async ({ queryKey }) => {
	const [_key, collegeId, classId, index, admnType, userId] = queryKey;

	try {
		const instance = await getAxiosTokenInstance();
		const { data } = await instance.get('/college/admissionProcess2/getAdmissionValidator', {
			params: { collegeId, userId, classId, index, admnType },
		});
		if (data?.statusCode === 200) {
			return data;
		} else {
			throw new Error(data?.message || 'Failed to fetch college details.');
		}
	} catch (error) {
		throw new Error('API Error');
	}
};

function AdmissionVerificationProcess({ userId, isStudent, stateData, refectData, whoAdmin, previousKeyMap, setStateData, keyData, onClose }) {
	const { data: userDetail, refetch: refetchUserDetail } = useProfileData(userId, !isStudent);
	const studentData = userDetail;



	const { collegeId } = useContext(NecttosContext);
	const [state, setState] = useState({ admissionNo: '', admnType: userDetail?.admnType || ' Not provided' });

	const [values, setValues] = useState('');
	const [states, setStates] = useState({ admissionNo: '' });
	const [editMode, setEditMode] = useState(false);
	const [originalNo, setOriginalNo] = useState('');
	const [admType, setAdmType] = useState(userDetail?.admnType || 'Not provided');
	const [isSaving, setIsSaving] = useState(false);
	const admnTypeOptions = ['OPEN', 'LC', 'OBH', 'EWS', 'EZ', 'JR', 'LDWP', 'SC', 'MU', 'PwD', 'OBX', 'SSQ', 'TLM', 'ETB', 'UTL', 'PH', 'ST', 'PWD', 'SP'].map((val) => ({ label: val, value: val }));

	useEffect(() => {
		const fetchData = async () => {
			const instance = await getAxiosTokenInstance();
			try {
				const resp = await instance.get('/college/admissionProcess2/getFalseNumber', {
					params: { collegeId },
				});

				if (resp.data.statusCode === 400) {
					throw new Error(resp.data.message || 'API Error');
				} else {
					const no = parseInt(resp.data?.admissionNo || '0', 10);
					const incremented = (no + 1).toString();
					setStates((prev) => ({ ...prev, admissionNo: incremented }));
					setOriginalNo(no.toString());
				}
			} catch (error) {
				console.error('Error fetching admission number:', error);
			}
		};

		fetchData();
	}, [collegeId]);

	

	// Update state when userDetail changes
	useEffect(() => {
		if (userDetail) {
			setState((prev) => ({
				...prev,
				dateTimer: new Date(),
				admnType: userDetail?.admnType || '',
			}));
		}
	}, [userDetail]);


	const handleUpdateAdmnType = async () => {
		const payload = {
			userId,
			collegeId,
			profile: {
				admnType: state?.admnType || '',
			},
		};
		await updateProfile(payload);
	};

	const updateProfile = async (payload) => {
		setIsSaving(true);
		try {
			const instance = await getAxiosTokenInstance();
			const resp = await instance.post('/college/admissionProcess2/editupdateProfile', payload);
			if (!resp) {
				throw new Error('Failed to update profile');
			}
			const data = resp;
			console.log('Profile updated successfully');

			if (refetchUserDetail) {
				await refetchUserDetail();
			}

			setIsSaving(false);

			return data;
		} catch (error) {
			console.error('Error updating profile:', error);
			setIsSaving(false);
			throw error;
		}
	};

	// const fetchValidatorData = async (admTypeFromDB) => {
	// 	try {
	// 		const instance = await getAxiosTokenInstance();

	// 		const classIdResp = await instance.get('/college/admissionProcess2/getClassIdByUser', {
	// 			params: { userId, collegeId },
	// 		});

	// 		const classId = classIdResp?.data?.classId;

	// 		if (!classId) {
	// 			console.warn('No classId found for this user');
	// 			return;
	// 		}

	// 		const { data } = await instance.get('/college/admissionProcess2/getAdmissionValidator', {
	// 			params: {
	// 				collegeId,
	// 				classId,
	// 				index: state?.index || 0,
	// 				admnType: admTypeFromDB,
	// 			},
	// 		});

	// 		setValidatorInfo(data || null);
	// 	} catch (err) {
	// 		console.error('Error fetching validator data', err);
	// 	}
	// };


	const handleCall = () => {
		setState({ ...state, callCandidate: true });
	};

	const handleVerify = () => {
		setState({ ...state, verificationStudent: true });
	};

	const handleReject = () => {
		setState({ ...state, handleReject: true });
	};

	const handleEdit = () => {
		setState({ ...state, handleEdit: true });
	};

	const handleGiveTime = () => {
		setState({ ...state, handleGiveTime: true });
	};

	const rewardback = () => {
		setState({ ...state, rewardBack: true });
	};
	const { data: validatorInfo } = useQuery([`admissionValidationData`, collegeId, studentData?.collegeRoles?.[0]?.classId, studentData?.index, admType, userId], getCollegeDetails);


	if (!userId) {
		return (
			<div>
				<div>Select A User First</div>
			</div>
		);
	}

	return (
		<Main width={'95%'} height={'90%'} title='Verification Window'>
			<Header>
				<div></div>
				<div className='flex justify-end'>
					<Button type='close' onClick={onClose}>
						close
					</Button>
				</div>
			</Header>

			<Body>
				<div className='flex w-full justify-center items-center'>
					<div className='flex flex-col items-center w-full max-w-3xl p-8 rounded-3xl shadow-2xl backdrop-blur-xl bg-gradient-to-br from-white/30 to-slate-100/20 dark:from-slate-800/50 dark:to-slate-900/30 text-white'>
						<div className='flex justify-center gap-4 mb-6'>
							<button onClick={handleEdit} className='px-3 py-1.5 rounded-md bg-orange-500 text-white text-xs font-semibold shadow hover:scale-105 transition-transform flex items-center gap-1.5'>
								<svg xmlns='http://www.w3.org/2000/svg' className='h-4 w-4' fill='none' viewBox='0 0 24 24' stroke='currentColor'>
									<path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M11 17h2m2-2l6 6M2 12l6-6 6 6' />
								</svg>
								Edit
							</button>

							<button onClick={handleGiveTime} className='px-3 py-1.5 rounded-md bg-purple-500 text-white text-xs font-semibold shadow hover:scale-105 transition-transform flex items-center gap-1.5'>
								<svg xmlns='http://www.w3.org/2000/svg' className='h-4 w-4' fill='none' viewBox='0 0 24 24' stroke='currentColor'>
									<path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z' />
								</svg>
								Give Time
							</button>
							<button onClick={rewardback} className='px-3 py-1.5 rounded-md bg-red-400 text-white text-xs font-semibold shadow hover:scale-105 transition-transform flex items-center gap-1.5'>
								<svg xmlns='http://www.w3.org/2000/svg' className='h-4 w-4' fill='none' viewBox='0 0 24 24' stroke='currentColor'>
									<path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M11 19l-9-7 9-7v14zm10 0l-9-7 9-7v14z' />
								</svg>
								Revert Back
							</button>
						</div>
						<p
							style={{
								color: !userDetail?.admisionNo || userDetail?.admisionNo === '' || userDetail?.admisionNo === 'undefined' ? '#EF4444' : '#22C55E',
								padding: '6px',
								borderRadius: '6px',
								fontWeight: 600,
								textAlign: 'center',
							}}>
							{userDetail?.remarks && typeof userDetail.remarks === 'string' && userDetail.remarks.trim() !== '' ? `Remarks : ${userDetail.remarks}` : 'No Remarks'}
						</p>
						<div
							style={{
								backgroundColor: !userDetail?.admisionNo || userDetail.admisionNo === '' || userDetail.admisionNo === 'undefined' ? '#EF4444' : '#22C55E',
								padding: '2px 5px',
								borderRadius: '8px',
								margin: '12px 0',
								textAlign: 'center',
							}}>
							<p style={{ color: '#fff', fontWeight: 600 }}>{userDetail?.admisionNo && userDetail.admisionNo !== '' && userDetail.admisionNo !== 'undefined' ? `Admission Number: ${userDetail.admisionNo}` : 'No admission number assigned yet'}</p>
						</div>
						<TimerFunction start={true} date={state?.dateTimer} />
						<div className='relative w-80 h-80 mb-6'>
							<img src={studentData?.photoURL || notFoundProfile} alt={studentData?.name || 'Name'} className='w-full h-full object-cover rounded-2xl shadow-lg' />
							<div className='absolute bottom-0 left-0 w-full bg-black/50 backdrop-blur-sm rounded-b-2xl p-2'>
								<div className='flex items-center justify-between'>
									<div className='text-left ml-2'>
										<h2 className='text-xl font-bold text-white'>{studentData?.name}</h2>
										<p className='text-sm text-white/80'>{studentData?.shortName} - Batch: </p>
										<p className='text-sm text-white/80'>{studentData?.batchName}</p>
									</div>
									<button onClick={handleCall} className='flex items-center flex-col gap-1 px-3 py-3 rounded-xl bg-green-600 text-white text-xs font-semibold hover:scale-105 transition-transform'>
										<svg xmlns='http://www.w3.org/2000/svg' className='h-4 w-4 ml-1' fill='none' viewBox='0 0 24 24' stroke='currentColor'>
											<path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M3 5a2 2 0 012-2h1.586a1 1 0 01.707.293l2.828 2.828a1 1 0 01.293.707V9a1 1 0 01-.293.707L8.414 11H7v2h1.414l1.293 1.293A1 1 0 0110 15v1.586a1 1 0 01-.293.707l-2.828 2.828a1 1 0 01-.707.293H5a2 2 0 01-2-2V5z' />
										</svg>
										<div>call</div>
									</button>
								</div>
							</div>
						</div>

						<div className='flex justify-center gap-6 mt-4'>
							<button onClick={handleReject} className='w-[200px] h-[50px] rounded-xl bg-gradient-to-r from-red-400 to-red-600 text-white font-semibold shadow-lg hover:scale-[1.02] transition-transform backdrop-blur-sm flex items-center justify-center gap-2'>
								<svg xmlns='http://www.w3.org/2000/svg' className='h-5 w-5' fill='none' viewBox='0 0 24 24' stroke='currentColor'>
									<path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M6 18L18 6M6 6l12 12' />
								</svg>
								Reject
							</button>

							<button onClick={handleVerify} className='w-[200px] h-[50px] rounded-xl bg-gradient-to-r from-blue-400 to-blue-600 text-white font-semibold shadow-lg hover:scale-[1.02] transition-transform backdrop-blur-sm flex items-center justify-center gap-2'>
								<svg xmlns='http://www.w3.org/2000/svg' className='h-5 w-5' fill='none' viewBox='0 0 24 24' stroke='currentColor'>
									<path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M5 13l4 4L19 7' />
								</svg>
								Verify
							</button>
						</div>
						<div className='w-full max-w-md mb-4'>
							<div className='w-full max-w-md mb-4'>
								<div className='flex items-center gap-2'>
									<Input2 type='drop'   className="w-[400px] text-black dark:text-white bg-slate-300 dark:bg-gray-800 border border-gray-300 dark:border-gray-600"  fieldName='Admission Type' options={admnTypeOptions} optionKey='value' optionDisplay='label' state={admType} setState={setAdmType} />
									<button onClick={handleUpdateAdmnType} disabled={isSaving} className='px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 disabled:bg-gray-400 text-sm font-semibold whitespace-nowrap'>
										{isSaving ? 'Updating...' : 'Update'}
									</button>
								</div>
								{validatorInfo && (
									<div className='mt-4 bg-slate-100 dark:bg-slate-800 p-4 rounded-md border dark:border-slate-600 text-sm'>
										<h3 className='font-semibold text-lg mb-2 text-blue-800 dark:text-blue-300'>Admission Validation Summary</h3>
										<p>
											<strong>Class:</strong> {validatorInfo.className}
										</p>
										<p>
											<strong>Selected Type Statistics:</strong>
											{validatorInfo.inTakeKey}/ {validatorInfo.limited}
										</p>
										<p>
											<strong>Index Permission:</strong> {validatorInfo.isIndexAllow}
										</p>
										<p>
											<strong>Reservation Permission:</strong> {validatorInfo.isReservationAllow}
										</p>
										<p>
											<strong>Lowest Open Index:</strong> {validatorInfo.loweIndexOpen}
										</p>
									</div>
								)}
							</div>
						</div>
					</div>
				</div>
			</Body>

			{/* Modals (unchanged) */}
			{state?.rewardBack && (
				<Rewardback
					userId={userId}
					isStudent={true}
					keyData={keyData}
					startDateTimer={state.dateTimer}
					TimerFunction={TimerFunction}
					state={values}
					setState={setValues}
					keyDataBack={previousKeyMap[keyData]}
					parentOnClose={onClose}
					onClose={() => {
						setState({ ...state, rewardBack: false });
					}}
					refectData={refectData}
					whoAdmin={whoAdmin}
				/>
			)}

			{state?.handleEdit && (
				<ApplicationOpen
					userId={userId}
					isStudent={true}
					keyData={keyData}
					startDateTimer={state.dateTimer}
					TimerFunction={TimerFunction}
					state={values}
					setState={setValues}
					parentOnClose={onClose}
					onClose={() => {
						setState({ ...state, handleEdit: false });
					}}
					refectData={refectData}
					whoAdmin={whoAdmin}
				/>
			)}

			{state?.handleGiveTime && (
				<HandleGiveTime
					userId={userId}
					isStudent={true}
					keyData={keyData}
					startDateTimer={state.dateTimer}
					TimerFunction={TimerFunction}
					stateData={state}
					setStateData={setState}
					parentOnClose={onClose}
					onClose={() => {
						setState({ ...state, handleGiveTime: false });
					}}
					refectData={refectData}
					whoAdmin={whoAdmin}
				/>
			)}

			{state?.handleReject && (
				<HandleReject
					userId={userId}
					isStudent={true}
					keyData={keyData}
					startDateTimer={state.dateTimer}
					TimerFunction={TimerFunction}
					stateData={state}
					setStateData={setState}
					parentOnClose={onClose}
					onClose={() => {
						setState({ ...state, handleReject: false, verificationProcess: true });
					}}
					refectData={refectData}
					whoAdmin={whoAdmin}
				/>
			)}

			{state?.handleProceed && (
				<HandleProceed
					userId={userId}
					isStudent={true}
					keyData={keyData}
					startDateTimer={state.dateTimer}
					TimerFunction={TimerFunction}
					stateData={state}
					setStateData={setState}
					parentOnClose={onClose}
					onClose={() => {
						setState({ ...state, handleProceed: false });
					}}
				/>
			)}

			{state?.verificationStudent && (
				<VerificationStudent
					userId={userId}
					isStudent={true}
					keyData={keyData}
					startDateTimer={state.dateTimer}
					TimerFunction={TimerFunction}
					stateData={state}
					setStateData={setState}
					parentOnClose={onClose}
					onClose={() => {
						setState({ ...state, verificationStudent: false });
					}}
				/>
			)}

			{state?.callCandidate && (
				<CallCandidate
					userId={userId}
					isStudent={true}
					keyData={keyData}
					startDateTimer={state.dateTimer}
					TimerFunction={TimerFunction}
					stateData={state}
					setStateData={setState}
					parentOnClose={onClose}
					onClose={() => {
						setState({ ...state, callCandidate: false });
					}}
				/>
			)}
		</Main>
	);
}

export default AdmissionVerificationProcess;
